module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('project-header', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.firstSection), function(image) {
    return _c('div', {
      key: image,
      staticClass: "col-12 project-gallery__img"
    }, [_c('img', {
      staticClass: "project-gallery__image",
      attrs: {
        "src": ("/static/images/een/" + image)
      }
    })])
  }), _vm._v(" "), _c('project-footer', {
    attrs: {
      "prev": "/work/get-clean",
      "next": "/work/by-wood"
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-gallery row"
  }, [_c('div', {
    staticClass: "col-12 ta-center"
  }, [_c('video', {
    staticClass: "project-gallery__fullsize-video project-gallery__video--medium",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/een/een-logo-gif.mp4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 ta-center een__logo-gif"
  }, [_c('video', {
    staticClass: "project-gallery__fullsize-video project-gallery__video--medium",
    attrs: {
      "playsinline": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/videos/een/een-logo-gif-2.mp4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94e61a42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/Een.vue
// module id = 395
// module chunks = 2